import { constants } from "@newsela/angelou";

const neutralGrey = constants.colors.ui.neutral[100];

export const activityCardCss = {
  h2: {
    display: "none",
  },
  ">div": {
    minHeight: "200px !important",
  },
  height: "242px",
};

export const footerCss = {
  borderTop: `1px solid ${neutralGrey}`,
  margin: "0 -24px -24px",
  padding: "0 24px",
};

export const footerViewLinkCss = {
  textDecoration: "none",
};
